import React, { ReactNode } from "react";
import classNames from "classnames/dedupe";

import "../../page-layout.scss";

type TPageLayoutType = "same-height-row" | "flex-column";

interface IPageContentProps {
    children: ReactNode;
    className?: string;
    layout?: TPageLayoutType;
}

const PageContent: React.FC<IPageContentProps> = ({ 
    children,
    className,
    layout = "same-height-row"
}) => {
    const layoutClassMap = {
        "same-height-row": "table-grid-layout",
        "flex-column": "flex-column"
    };

    return (
        <div
            id="page-container"
            className={classNames(
                "rui-page-content",
                layoutClassMap[layout],
                className
            )}
        >
            {children}
        </div>
    );
};

export default PageContent;
